<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { axiosGetPost } from '@router/axiosGetPost'
import TransitTimeTable from '@src/components/datatablegn/TransitTimeTable'
import HarborManager from '@components/contract/harbor-manager'
import CarrierManager from '@components/contract/carrier-manager'
import CreateTransitTime from "@components/transit_times/CreateTransitTime.vue"

import XLSX from 'xlsx'

export default {
  page: {
    title: 'Transit Times',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    TransitTimeTable,
    HarborManager,
    CarrierManager,
    CreateTransitTime,
  },
  data() {
    return {
      title: 'Transit Times',
      loandingDataTT: false,
      loandingDataFailTT: false,
      loandingBTab: false,
      isTesting: false,
      dataTT: [[]],
      dataFailTT: [[]],
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Transit Times',
          href: '/transittimes',
          active: true,
        },
        {
          text: 'List',
          active: true,
        },
      ],
      loadingData: false,
      modalComponent: null,
      modalTitle: 'Status',
      modalError: null,
      modalErrorShow: false,
      showModal: false,
    }
  },
  computed: {},
  created() {
    if (this.isTesting) {
      this.testData()
    } else {
      this.fetchData()
    }
  },
  mounted() {},
  methods: {
    testData() {
      this.loandingDataRates = false
    },
    updateTableM(type, table = []) {
      table.forEach((element) => {
        this.callDatatable(type, element)
      })
    },
    fetchData() {
      this.callDatatable('transitt', 'good')
      this.callDatatable('transitt', 'fail')
    },
    callDatatable(table, mode) {
      let loadings = {
        transitt: { good: 'loandingDataTT', fail: 'loandingDataFailTT' },
      }
      let variable = {
        transitt: { good: 'dataTT', fail: 'dataFailTT' },
      }
      this[loadings[table][mode]] = true
      axiosGetPost('post', 'transit_times/list', {
        mode: mode,
      }).then((response) => {
        let data = response.data
        console.log(data)
        this[variable[table][mode]] = data
        this[loadings[table][mode]] = false
        this.showModal = false
        return data
      })
    },
    downloadFileTemplate(id) {
      axiosGetPost('get', '/transit_times/template').then((response) => {
        let data = response.data
        var wb = XLSX.utils.book_new() // make Workbook of Excel
        var wscols = [{ wch: 25 }, { wch: 25 }]
        for (let i = 0; i <= Object.keys(data.table[0]).length - 2; i++) {
          wscols.push({ wch: 20 })
        }
        var dataXLSX = XLSX.utils.json_to_sheet(data.table)
        dataXLSX['!cols'] = wscols
        XLSX.utils.book_append_sheet(wb, dataXLSX, 'Hoja1') // sheetAName is name of Worksheet
        XLSX.writeFile(wb, data.name) // name of the file is 'book.xlsx'
        return response
      })
    },
    addVariation(type = 'harbors') {
      this.showModal = true
      const types = {
        harbors: 'HarborManager',
        carriers: 'CarrierManager',
      }
      this.modalComponent = types[type]
      this.modalTitle = 'Add Variation ' + types[type]
    },
    addTransitTime(){
      this.modalComponent = 'CreateTransitTime'
      this.modalTitle = 'Create Transit Time'
      this.showModal = true
    },
    saveModal() {
      this.showModal = false
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="form-group row">
              <div class="mb-md-2 col-md-8">
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Download Template"
                  @click="downloadFileTemplate"
                  >Download Template
                  <i class="uil uil-cloud-download"></i> </button
                >&nbsp;
                <router-link
                  class="btn btn-sm my-0 btn-outline-primary"
                  title="Add Surcharge"
                  href="#"
                  :to="{
                    name: 'transit_time_import',
                  }"
                  >Importation&nbsp;
                  <i class="uil uil-cloud-upload"></i>
                </router-link>
                &nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Add Surcharge"
                  @click="addVariation('harbors')"
                  >Variations Harbors
                  <i class="uil uil-plus"></i>
                </button>
                &nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Carrier Manager"
                  @click="addVariation('carriers')"
                  >Variations Carriers
                  <i class="uil uil-plus"></i>
                </button>
                &nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Add Transit time"
                  @click="addTransitTime()"
                  >Add Transit Time
                  <i class="uil uil-plus"></i>
                </button>
                &nbsp;
              </div>
            </div>
            <div class="row">
              <div class="mb-md-2 col-md-12">
                <b-tabs align="center">
                  <!-- Fail Rates Tab **************************************************************  -->
                  <b-tab active>
                    <template #title>
                      <i
                        class="uil uil-times-circle"
                        style="font-size: 13px; color: brown"
                      ></i>
                      &nbsp; <strong>Fail</strong>
                    </template>
                    <div
                      v-if="loandingDataFailTT"
                      class="row align-items-center justify-content-center"
                      style="height: 300px"
                    >
                      <div class="col-12 col-md-8 text-center">
                        <b-spinner
                          label="Loading..."
                          variant="secondary"
                          class="ml-3"
                        ></b-spinner>
                      </div>
                    </div>
                    <div v-else>
                      <span
                        class="uil uil-thumbs-down mt-2"
                        style="color: brown"
                      >
                        &nbsp;
                      </span>
                      <strong>
                        Transit T. Failed: {{ dataFailTT[0].length }}</strong
                      >
                      <br />
                      <TransitTimeTable
                        :table-data="dataFailTT"
                        type-table="fail"
                        @update_table="updateTableM"
                        :inc-options="['editFails', 'delete']"
                      />
                    </div>
                  </b-tab>
                  <!-- Good Rates Tab **************************************************************  -->
                  <b-tab>
                    <template #title>
                      <i
                        class="uil uil-check-circle"
                        style="font-size: 13px; color: forestgreen"
                      ></i>
                      &nbsp;
                      <strong>Good</strong>
                    </template>
                    <div
                      v-if="loandingDataTT"
                      class="row align-items-center justify-content-center"
                      style="height: 300px"
                    >
                      <div class="col-12 col-md-8 text-center">
                        <b-spinner
                          label="Loading..."
                          variant="secondary"
                          class="ml-3"
                        ></b-spinner>
                      </div>
                    </div>
                    <div v-else>
                      <span
                        class="uil uil-thumbs-up mt-2"
                        style="color: forestgreen"
                      >
                        &nbsp; </span
                      ><strong>Transit T. Good : {{ dataTT[0].length }}</strong>
                      <TransitTimeTable
                        :table-data="dataTT"
                        type-table="good"
                        @update_table="updateTableM"
                        :inc-options="['edit', 'delete']"
                      />
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        id="modal-lg"
        ref="requestFcl"
        v-model="showModal"
        size="lg"
        :title="modalTitle"
        title-class="font-18"
      >
        <div
          v-if="loadingData"
          class="row align-items-center justify-content-center"
          style="height: 300px"
        >
          <div class="col-12 col-md-8 text-center">
            <b-spinner
              label="Loading..."
              variant="primary"
              class="ml-3"
            ></b-spinner>
          </div>
        </div>

        <div v-else-if="modalErrorShow === true">
          <div
            class="row align-items-center justify-content-center"
            style="height: 300px"
          >
            <div class="col-12 col-md-8 text-center">
              <feather type="frown" class="icon-xxl icon-dual-info"></feather>
              <h6 class="text-muted">{{ modalError }}</h6>
            </div>
          </div>
        </div>
        <HarborManager
          v-if="modalComponent === 'HarborManager' && loadingData === false"
        />
        <CarrierManager
          v-if="modalComponent === 'CarrierManager' && loadingData === false"
        />
        <CreateTransitTime
          v-if="modalComponent === 'CreateTransitTime' && loadingData === false"
          @update_table="updateTableM"
        />
        <template v-slot:modal-footer>
          <b-button variant="light" @click="saveModal">Close</b-button>
          <b-button
            v-if="
              loadingData === false &&
              modalErrorShow === false &&
              modalComponent === ''
            "
            variant="primary"
            @click="saveModal"
          >
            OK
          </b-button>
        </template>
      </b-modal>
    </div>
  </Layout>
</template>
<style type="text/css">
.show .btn-success.dropdown-toggle {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.text {
  font-family: helvetica;
  font-weight: bold;
  color: #71d90b;
}
</style>